export default __webpack_public_path__ + "static/sepana-25f8dd7a1569ba68747d2f21e19f1354.png";